/**
 * React Native WebView との通信ブリッジ
 * アプリ側で権限を取得済みの場合、WebView側での権限リクエストをスキップする
 */

export function isInNativeApp() {
  return window.isNativeApp === true || window.ReactNativeWebView !== undefined;
}

/**
 * ネイティブからのGPS位置情報を購読する
 * @param {Function} callback - { lat: number, lng: number, accuracy: number } を受け取るコールバック
 * @returns {Function} 購読解除関数
 */
export function subscribeNativeGps(callback) {
  if (typeof window.subscribeNativeGps === "function") {
    return window.subscribeNativeGps(callback);
  }
  return () => {};
}

/**
 * ネイティブからの方位（コンパス）情報を購読する
 * @param {Function} callback - { heading: number } を受け取るコールバック (0-360度、北=0)
 * @returns {Function} 購読解除関数
 */
export function subscribeNativeHeading(callback) {
  if (typeof window.subscribeNativeHeading === "function") {
    return window.subscribeNativeHeading(callback);
  }
  return () => {};
}

/**
 * ネイティブアプリ内でGPS権限が許可されているかどうか
 * @returns {boolean}
 */
export function hasNativeGpsPermission() {
  return window.nativeGpsPermission === true;
}
